import { render } from "./ShowPodani.vue?vue&type=template&id=95e15c3a"
import script from "./ShowPodani.vue?vue&type=script&lang=js"
export * from "./ShowPodani.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__